import { render, staticRenderFns } from "./SiteTemplate.vue?vue&type=template&id=84aed34e&scoped=true"
import script from "./SiteTemplate.vue?vue&type=script&lang=js"
export * from "./SiteTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aed34e",
  null
  
)

export default component.exports